import { FC } from "react";

interface canvasHeaderProps {
  crumbs: string[];
  itemCount?: number;
  itemNoun?: string;
  selectedCount?: number;
  onCrumbSelect?: (crumbIndex: number) => void;
}

// Head of the canvas: the breadcrumb trail on the left, with the last entry
// rendered as the current location, and what the canvas holds on the right.
// Every entry before the last takes you back to that level when clicked. The
// model viewer has no count to give, so the right side is left empty.

const CanvasHeader: FC<canvasHeaderProps> = ({
  crumbs,
  itemCount,
  itemNoun = "item",
  selectedCount = 0,
  onCrumbSelect,
}) => {
  return (
    <div className="canvasHeader">
      <div className="canvasHeaderCrumbs">
        {crumbs.map((crumb, index) => (
          <span
            key={`${crumb}-${index}`}
            className={index === crumbs.length - 1 ? "crumbCurrent" : ""}
          >
            {index > 0 ? "/ " : ""}
            {onCrumbSelect && index < crumbs.length - 1 ? (
              <button
                type="button"
                className="crumbLink"
                onClick={() => onCrumbSelect(index)}
              >
                {crumb}
              </button>
            ) : (
              crumb
            )}
          </span>
        ))}
      </div>
      {itemCount !== undefined && (
        <span>
          {itemCount} {itemCount === 1 ? itemNoun : `${itemNoun}s`}
          {selectedCount > 0 ? ` · ${selectedCount} selected` : ""}
        </span>
      )}
    </div>
  );
};

export default CanvasHeader;
